const DEFAULT_RESOURCE_TYPES = ['graphic', 'panel', 'theme', 'poll'];

export default {
  namespaced: true,

  state: {
    searchTerm: '',
    selectedTagNames: [],
    allTags: [],
    selectedResourceTypes: [],
  },

  mutations: {
    SET_SEARCH_TERM(state, value) {
      state.searchTerm = value;
    },

    SET_SELECTED_TAG_NAMES(state, tags) {
      state.selectedTagNames = tags;
    },

    SET_ALL_TAGS(state, tags) {
      state.allTags = tags;
    },

    SET_SELECTED_RESOURCE_TYPES(state, types) {
      state.selectedResourceTypes = types;
    },

    REMOVE_TAG(state, tag) {
      state.selectedTagNames = state.selectedTagNames.filter((t) => t !== tag);
    },

    RESET_FILTERS(state) {
      state.searchTerm = '';
      state.selectedTagNames = [];
      state.selectedResourceTypes = [];
    },
  },

  getters: {
    effectiveResourceTypes(state) {
      return state.selectedResourceTypes.length
        ? state.selectedResourceTypes
        : DEFAULT_RESOURCE_TYPES;
    },

    hasNonDefaultResourceTypes(state) {
      return state.selectedResourceTypes.length > 0;
    },

    hasActiveFilters(state) {
      return !!state.searchTerm || state.selectedTagNames.length > 0 || state.selectedResourceTypes.length > 0;
    },
  },
};
